import {
  Input,
  Select,
  Submit,
  Textarea,
  TagSelect,
  DateSelect,
} from "./services/components";
import Toastify from "toastify-js";
import { useEffect, useState } from "react";
import Editor from "./services/Editor";
import { useGQLForm } from "./services/hooks";

const DataQuery = {
  snippet: ['snippets?id=eq.$id', false]
}
const CreateQuery = ['snippets', 'POST']
const UpdateQuery = ['snippets?id=eq.$id', 'PATCH']

const parseData = (data) => ({
  ...data,
  ad_or_not: parseInt(data.ad_or_not),
  type: "snippet",
});

export default () => {
  const {
    register,
    setValue,
    handleSubmit,
    onSubmit,
    error,
    data,
    idExists,
    id,
  } = useGQLForm({
    DataQuery,
    CreateQuery,
    UpdateQuery,
    parseData,
    path: "snippets",
    createKey: "createSnippet",
    afterSubmit: () => {
      Toastify({
        text: "Zapisano",
        gravity: "bottom",
      }).showToast();
    },
  });

  const getData = (key, def) => (idExists ? data.snippet[key] : def);

  useEffect(() => {
    if (!data && idExists) return () => {};

    register("htmlcontent", {
      value: getData("htmlcontent", "[]"),
    });
  }, [data]);

  if (error || (!data && idExists)) return <div>Loading...</div>;
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="container px-4 mx-auto py-8">
        <Input
          label="Nazwa"
          placeholder="Wpisz nazwę"
          {...register("name")}
          defaultValue={getData("name", "")}
        />

        <Input
          label="Reklama = 1, nie reklama = 0"
          placeholder="Wpisz reklamę"
          {...register("ad_or_not")}
          defaultValue={getData("ad_or_not", "")}
        />

        <div className="z-0 relative">
          <Editor
            onChange={(value) => setValue("htmlcontent", value)}
            htmlContent={getData("htmlcontent", "[]")}
          />
        </div>
        <Submit />
      </div>
    </form>
  );
};
